import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Card,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { MdAddTask, MdAttachMoney, MdBarChart, MdBatteryCharging60, MdFileCopy, MdMoney, MdMoneyOff, MdSearch } from "react-icons/md";
import formatNumber from "../order/hooks/formatNumber";
import FinanceiroTable from "./components/Table";
import useFinanceiro from "./hooks/useFinanceiro";

const Finance = () => {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const {
    accountSelected,
    changeInput,
    error,
    errorMsg,
    errorTitle,
    list,
    loading,
    show,
    showDelete,
    showModal,
    usuario,
    cancelRef,
    closeError,
    closeDelete,
    add,
    deletar,
    edit,
    showDeleteModal,
    dataFim,
    dataInicio,
    searchData,
    calculateRecebido,
    calculateAReceber,
    calculateAPagar,
    calculatePago,
    calculateRecebimentosAtraso,
    calculatePagamentosAtraso,
    calculateCaixa,
    addToList,
    pagar,
    removerPagamento,
    selectedList
  } = useFinanceiro();
  const textColor = useColorModeValue("secondaryGray.900", "white");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Recebido"
          value={formatNumber(calculateRecebido())}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBarChart} color={brandColor} />
              }
            />
          }
          name="Á Receber"
          value={formatNumber(calculateAReceber())}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name="Pago"
          value={formatNumber(calculatePago())}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name="Á Pagar"
          value={formatNumber(calculateAPagar())}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg="linear-gradient(90deg, #4481EB 0%, #04BEFE 100%)"
              icon={<Icon w="28px" h="28px" as={MdAddTask} color="white" />}
            />
          }
          name="Recebimentos em Atraso"
          value={formatNumber(calculateRecebimentosAtraso())}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdFileCopy} color={brandColor} />
              }
            />
          }
          name="Pagamentos em Atraso"
          value={formatNumber(calculatePagamentosAtraso())}
        />

      <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBatteryCharging60} color={brandColor} />
              }
            />
          }
          name="Previsão de Entradas"
          value={formatNumber(Number(calculateAReceber()) + Number(calculateRecebido()))}
        />
      <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdBatteryCharging60} color={brandColor} />
              }
            />
          }
          name="Previsão de Fluxo de Caixa"
          value={formatNumber( calculateCaixa())}
        />
      </SimpleGrid>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <Card>
          <Flex
            px="25px"
            mb="16px"
            mt="16px"
            justifyContent="space-between"
            align="center"
          >
            <Text
              color={textColor}
              fontSize="22px"
              fontWeight="700"
              lineHeight="100%"
            >
              Filtrar Lançamentos:
            </Text>
          </Flex>
          <Box flex="1" flexDirection={"row"}>
            <FormControl float={"left"} w={320} p={4} mr={4}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Data Inicio
              </FormLabel>

              <SingleDatepicker
                name="date-input-datainicio"
                configs={{
                  dateFormat: "dd/MM/yyyy",
                  dayNames: "DSTQQSS".split(""), // length of 7
                  monthNames:
                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                      " "
                    ), // length of 12
                  firstDayOfWeek: 0,
                  // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                }}
                propsConfigs={{
                  dayOfMonthBtnProps: {
                    selectedBtnProps: {
                      background: "#422afb",
                      color: "white",
                    },
                  },
                }}
                date={dataInicio}
                onDateChange={(date: any) => {
                  changeInput(date, "inicio");
                }}
              />
            </FormControl>

            <FormControl float={"left"} w={320} p={4} mr={4}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Data Fim
              </FormLabel>

              <SingleDatepicker
                name="date-input-datafim"
                configs={{
                  dateFormat: "dd/MM/yyyy",
                  dayNames: "DSTQQSS".split(""), // length of 7
                  monthNames:
                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                      " "
                    ), // length of 12
                  firstDayOfWeek: 0,
                  // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                }}
                propsConfigs={{
                  dayOfMonthBtnProps: {
                    selectedBtnProps: {
                      background: "#422afb",
                      color: "white",
                    },
                  },
                }}
                date={dataFim}
                onDateChange={(date: any) => {
                  changeInput(date, "fim");
                }}
              />
            </FormControl>

            <Button
              leftIcon={<MdSearch />}
              colorScheme="green"
              variant="solid"
              float={"left"}
              mt={10}
              onClick={() => { searchData();}}
            >
              Buscar
            </Button>
          </Box>
        </Card>

        <Card>
          <Flex
            px="25px"
            mb="16px"
            mt="16px"
            justifyContent="space-between"
            align="center"
          >
            <Text
              color={textColor}
              fontSize="22px"
              fontWeight="700"
              lineHeight="100%"
            >
              Com os itens marcados:
            </Text>
          </Flex>
          <Stack direction="row" spacing={4} p={4}>
                <Button
                  leftIcon={<MdMoney />}
                  colorScheme="brand"
                  size={'sm'}
                  isLoading={loading}
                  onClick={() => pagar()}
                  variant="solid"
                >
                  Compensar
                </Button>
                <Button
                  leftIcon={<MdMoneyOff />}
                  colorScheme="brand"
                  size={'sm'}
                  onClick={()=> removerPagamento()}
                  isLoading={loading}
                  variant="solid"
                >
                  Descompensar
                </Button>
              </Stack>

        </Card>
        <FinanceiroTable
          add={add}
          cancelRef={cancelRef}
          closeDelete={closeDelete}
          deletar={showDeleteModal}
          edit={edit}
          list={list}
          remove={deletar}
          showDelete={showDelete}
          addToList={addToList}
          selectedList={selectedList}
        />

        <AlertDialog
          isOpen={error}
          leastDestructiveRef={cancelRef}
          onClose={closeError}
          isCentered
          motionPreset="slideInBottom"
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {errorTitle}
              </AlertDialogHeader>

              <AlertDialogBody>{errorMsg}</AlertDialogBody>

              <AlertDialogFooter>
                <Button
                  ref={cancelRef}
                  onClick={closeError}
                  colorScheme={"blue"}
                >
                  OK
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </SimpleGrid>
    </Box>
  );
};
export default Finance;
